export default function AboutSection() {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-enerverze-bg">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-[35%]">
            <div className="inline-flex items-center px-5 py-2 rounded-full border border-neon-cyan text-enerverze-text text-sm mb-12">
              About Us
            </div>
            <div className="rounded-3xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20exterior%20at%20night%20with%20subtle%20neon%20cyan%20accent%20lighting%20clean%20architecture%20dark%20slate%20sky%20professional%20tech%20company%20headquarters%20minimal%20futuristic%20design%20high%20quality%20photography&width=800&height=1000&seq=about1&orientation=portrait"
                alt="에너버즈 사옥"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-[65%] flex flex-col justify-center">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-enerverze-text leading-tight mb-6">
              AI와 에너지의
              <br />
              새로운 미래를
              <br />
              <span className="text-gradient-cyan">에너버즈</span>가 만듭니다
            </h2>
            <p className="text-base md:text-lg text-enerverze-muted leading-relaxed mb-4 max-w-2xl">
              (주)에너버즈는 2023년 설립된 AI 에너지 플랫폼 기업입니다.
              인공지능 기술과 에너지 산업의 융합을 통해
              스마트그리드, 디지털트윈, 분산에너지 네트워크 등
              차세대 에너지 인프라 솔루션을 개발하고 있습니다.
            </p>
            <p className="text-base md:text-lg text-enerverze-muted leading-relaxed mb-8 max-w-2xl">
              대표 김혜영을 중심으로, 에너지 전환과 탄소중립이라는
              글로벌 과제에 기술적으로 대응하며 B2G, B2B, 투자자,
              연구기관과 협력을 확대하고 있습니다.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#technology"
                className="inline-flex items-center self-start bg-enerverze-card text-enerverze-text px-6 py-3 rounded-xl text-sm font-medium hover:bg-neon-cyan hover:text-enerverze-bg transition-colors border-glow-cyan whitespace-nowrap"
              >
                기술 더보기
              </a>
              <a
                href="#contact"
                className="inline-flex items-center self-start text-neon-cyan hover:text-neon-green text-sm font-medium transition-colors whitespace-nowrap"
              >
                <span>협력 문의</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}